import React, { Component } from "react";
import { connect } from "react-redux";
import { Loader, Dimmer } from "semantic-ui-react";
import { connectSaga } from "../../util/hoc/connectSaga";
import { watchCollectionsRequests } from "./sagas";
import {
  loadCollection,
  loadMoreCollectionPosts,
  deleteCollection,
  cleanCurrentCollection,
  openEditCollectionFormModal,
} from "../../actions/collectionActions";
import { showConfirmDialog, hideConfirmDialog } from "../../actions";
import PostsList from "../../components/PostsList";
import CaseCardList from "../../components/PostsList/components/CaseCardList";
import CollectionHeader from "./components/CollectionHeader";
import CollectionHelmet from "./components/CollectionHelmet";
import NotFoundPage from "../../scenes/App404";
import { selectUser } from "../../util/selectors";

class CollectionPage extends Component {
  constructor(props) {
    super(props);

    this.loadMorePosts = this.loadMorePosts.bind(this);
  }

  componentDidMount() {
    this.props.actions.loadCollection({ collectionId: this.props.router.params.id });
  }

  componentWillUnmount() {
    this.props.actions.cleanCurrentCollection();
  }

  render() {
    const collection = this.props.collection;

    if (collection.error && collection.error.status === 404) {
      return <NotFoundPage />;
    }

    if (!collection._id) {
      return (
        <div className="padded">
          <Loader size="large" active inline="centered" />
        </div>
      );
    }

    return (
      <div className="collection-page">
        {this.props.collection.isDeleting && (
          <Dimmer active page>
            <div className="onboarding-container">
              <Loader>Loading</Loader>
            </div>
          </Dimmer>
        )}
        <CollectionHelmet collection={collection} />
        <CollectionHeader
          collection={collection}
          actions={this.props.actions}
          loggedInUser={this.props.user}
          isEditCollectionFormModalOpen={this.props.isEditCollectionFormModalOpen}
          collectionEditFormInitialValues={this.props.collectionEditFormInitialValues}
        />
        <PostsList posts={collection.posts} CaseListComponent={CaseCardList} loadMorePosts={this.loadMorePosts} />
      </div>
    );
  }

  loadMorePosts(options) {
    const collection = this.props.collection;
    this.props.actions.loadMoreCollectionPosts({ collectionId: collection._id, limit: collection.limit, ...options });
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    loadCollection: props => dispatch(loadCollection(props)),
    loadMoreCollectionPosts: props => dispatch(loadMoreCollectionPosts(props)),
    cleanCurrentCollection: () => dispatch(cleanCurrentCollection()),
    deleteCollection: collectionId => dispatch(deleteCollection(collectionId)),
    showConfirmDialog: options => dispatch(showConfirmDialog(options)),
    hideConfirmDialog: () => dispatch(hideConfirmDialog()),
    openEditCollectionFormModal: () => dispatch(openEditCollectionFormModal()),
  },
});

const mapStateToProps = state => ({
  router: state.router,
  collection: state.collections.current,
  user: selectUser(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(connectSaga(CollectionPage, watchCollectionsRequests));



// WEBPACK FOOTER //
// ./src/scenes/CollectionPage/index.js